import { type Category } from '../../types/search.types';
import { TrackedEvent, TrackedEventCase } from '../analytics/event-types';
import { type GTMEvent } from '../analytics/gtm/gtm-types';

export function buildGTMCategoryViewEvent(category: Category): GTMEvent {
	return {
		event: TrackedEvent.CATEGORY_VIEW,
		type: TrackedEventCase.CATEGORY_BROWSE_VIEW,
		categoryId: category.id,
		categoryName: category.name,
		categoryBreadcrumbs: category.breadcrumbs?.map((bc) => bc.name)
	};
}
